/**
 * Units and formatting settings depending on language
 */
export class LocaleSetting {
  /**
   * Constructor
   * @param {string} [chunkDelimiter='.']       Delimiter that occurs after every third digit
   * @param {string} [decimalDelimiter=',']     Delimiter that separates integer and decimals
   * @param {boolean} [symbolAfter=true]        True if currency symbol should be displayed after value
   * @param {string} [millionSuffix=' Mio.'     Abbreviation of 'million' that is displayed if value is 1 million or greater
   * @param {string} [dateFormatShort='DD.MM.'] Short form of date (day and month)
   */
  constructor(public chunkDelimiter: string = '.',
              public decimalDelimiter: string = ',',
              public symbolAfter: boolean = true,
              public millionSuffix: string = ' Mio.',
              public dateFormatShort: string = 'DD.MM.') {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/models/LocaleSettings.ts